import { render } from "./LandingGlobalWarmingExtremeWeather.vue?vue&type=template&id=d258bd12&ts=true"
import script from "./LandingGlobalWarmingExtremeWeather.vue?vue&type=script&lang=ts"
export * from "./LandingGlobalWarmingExtremeWeather.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__